import {
    /** FETCH PROFESSIONS  */
    FETCH_FORGOTPASSWORDVERIFY_FULFILLED,
    FETCH_FORGOTPASSWORDVERIFY_REJECTED,
    FETCH_FORGOTPASSWORDVERIFY_PENDING,
  } from "../../actions/auth/forgotPasswordVerify";
  const initialState = {
    done: false,
    loader: false,
    error: {},
  };

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FORGOTPASSWORDVERIFY_PENDING:
        return {
          done: false,
          spinner: true,
          error: {},
        };
      case FETCH_FORGOTPASSWORDVERIFY_FULFILLED:
        return {
          ...state,
          forgotPasswordVerify: action.payload,
          done: true,
          spinner: false,
        };
      case FETCH_FORGOTPASSWORDVERIFY_REJECTED:
        return {
          ...state,
          error: action.payload,
          spinner: false,
          done: false,
        };
      default:
        return state;
    }
  };